import View from './view';
import {VisuallyImpairedForm} from '../visuallyImpaired/form';
import {ViewProps} from 'react-native';
import React from 'react';
import {VisuallyImpairedProps} from '../visuallyImpaired/form/model';

export const VisuallyImpairedDesktop: React.FC<VisuallyImpairedProps & ViewProps> = (props) => {
  return VisuallyImpairedForm<ViewProps>({render: View, props});
};
